export enum Controls {
  Question = 1,
  Panel = 2,
  Page = 3,
  Boolean = 4,
  Textfield = 5,
  Number = 6,
  Percent = 7,
  Form = 8,
}
